import React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';

import { ApiService, Urls } from 'js/src/client';
import { selectWorkspaceByOrmId } from 'js/src/data/account';
import { ErrorReporter } from 'js/src/libs/error-reporter';
import type { RootState } from 'js/src/libs/RootState';

type PropsFromRedux = ConnectedProps<typeof connector>;
type OwnProps = {
    workspaceIdField: number;
};

const SelectWorkspaceRowPresentation = React.memo(function SelectWorkspaceRowPresentation({
    workspaceIdField,
    name,
    id,
}: PropsFromRedux & OwnProps) {
    const onClick = React.useCallback(
        async (e: React.MouseEvent<HTMLAnchorElement>) => {
            e.preventDefault();
            e.stopPropagation();

            try {
                analytics.track('Changed Workspace', {
                    workspace_id: id,
                });
                await ApiService.changeWorkspaceUpdate({
                    path: { workspace_id: id.toString() },
                });
                if (window.location.pathname === Urls.APP) {
                    window.location.href = Urls.DASHBOARD;
                } else {
                    window.location.reload();
                }
            } catch (e) {
                ErrorReporter.capture(e);
                alert('error changing workspaces - please reload page to try again');
            }
        },
        [id],
    );

    if (!name || id === -1) {
        return null;
    }
    return (
        <a className="dropdown-item" onClick={onClick}>
            {name}
        </a>
    );
});

const mapStateToProps = (state: RootState, ownProps: OwnProps) => {
    const workspace = selectWorkspaceByOrmId(state, ownProps.workspaceIdField);
    return {
        name: workspace?.name || '',
        id: workspace?.id || -1,
    };
};

const connector = connect(mapStateToProps);

const SelectWorkspaceRow = connector(SelectWorkspaceRowPresentation);

export default SelectWorkspaceRow;
